
import { computed, defineComponent } from "vue";

import TodoHeader from "@/components/TodoHeader.vue";
import TodoForm from "@/components/TodoForm.vue";
import TodoList from "@/components/TodoList.vue";
import TodoFooter from "@/components/TodoFooter.vue";
import TodoFilter from "@/components/shared/TodoFilter.vue";
import EmptyState from "./components/shared/EmptyState.vue";
import useTodo from "@/composables/useTodo";

export default defineComponent({
  name: "App",

  components: {
    TodoHeader,
    TodoForm,
    TodoList,
    TodoFooter,
    TodoFilter,
    EmptyState
  },

  setup() {
    const { todos, filteredTodos } = useTodo();

    const hasTodos = computed(
      () => todos.value.length || filteredTodos.value.length
    );

    return { hasTodos };
  }
});
